import { useCallback, useMemo } from 'react';

import { ReferralProgram } from 'modules/strapi/types';
import { removeReferralCodeFromUrl } from 'modules/referralProgram/utils/removeReferralCodeFromUrl';
import { useDialog } from 'modules/common/hooks/useDialog';
import { useRedirectToBilling } from 'modules/referralProgram/hooks/useRedirectToBilling';
import { useSavedReferralCode } from 'modules/referralProgram/hooks/useSavedReferralCode';

import { ISuccessDialogProps } from '../SuccessDialog';

export interface IUseSuccessDialogProps {
  cover: string;
  referralProgram: ReferralProgram | undefined;
}

export const useSuccessDialog = ({
  cover,
  referralProgram,
}: IUseSuccessDialogProps) => {
  const {
    isOpened,
    onClose: handleClose,
    onOpen: handleSuccessDialogOpen,
  } = useDialog();

  const { redirectToBilling } = useRedirectToBilling();

  const { handleRemoveSavedReferralCode } = useSavedReferralCode();

  const onClose = useCallback(() => {
    removeReferralCodeFromUrl();

    handleRemoveSavedReferralCode();

    handleClose();

    redirectToBilling();
  }, [handleClose, handleRemoveSavedReferralCode, redirectToBilling]);

  const successDialogProps = useMemo(
    (): ISuccessDialogProps => ({
      cover,
      onClose,
      onDoneButtonClick: onClose,
      open: isOpened,
      referralProgram,
    }),
    [cover, isOpened, onClose, referralProgram],
  );

  return { handleSuccessDialogOpen, successDialogProps };
};
